import { Component, ElementRef, ViewChild } from '@angular/core';
import { CamposComponent } from '../../../componentes/campos/campos.component';
import { CommonModule } from '@angular/common';
import { ReclamacionesService } from '../../../services/reclamaciones.service';
import {
  ReembolsosRequest,
  ReembolsosResponse,
  ReembolsoSaveRequest,
  CustomerInformationRequest,
  ClientAccount,
} from '../../../interfaces/reclamaciones.interface';
import { of, Subscription } from 'rxjs';
import { ReembolsosFilter } from '../../../interfaces/filters.interfaces';
import { FormsModule } from '@angular/forms';
import { formatAmount } from '../../../helpers/comificarInputsNumericos';
import { FileHandlerService } from '../../../services/filehandler.service';
import { map, switchMap } from 'rxjs/operators';
import { NotificationComponent } from '../../../paginas/pagos/pagos-online/helpers/notification.component';
import { AuthService } from '../../../services/auth.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics/google-analytics.service';

interface Servicio {
  nombre: string;
  fecha: string;
  monto: string;
  moneda: string;
  codigo: string;
}

@Component({
  selector: 'app-reembolsos',
  standalone: true,
  imports: [CommonModule, CamposComponent, FormsModule, NotificationComponent],
  templateUrl: './reembolsos.component.html',
  styleUrl: './reembolsos.component.css',
})
export class ReembolsosComponent {
  reembolsoData?: ReembolsosResponse;
  public hasSearched: boolean = false;
  errorStatus?: number;
  public today: string = new Date().toISOString().split('T')[0];
  selectedPaymentType: string = '';
  private currentSubscription?: Subscription;
  selectedPolicy: string = '';
  fechaServicio: string = '';
  monto: string = '';
  selectedCurrency: string = '';
  selectedBank: string = '';
  accountNumber: string = '';
  selectedAccountType: string = '';
  selectedCurrencyAccount: string = '';
  resumenServicios: string = '';
  hasServicio: boolean = false;
  selectedOrigin: string = '';
  selectedProcedure: string = '';
  title: string = '';
  claimNumber: number = 0;
  showConfirmModal: boolean = false;

  showMessageModal = false;
  responseMessage = '';
  currencyCode: string = '';
  servicioName: string = '';
  servicioAEliminar: number | undefined;
  servicios: Servicio[] = [];
  selectedFiles: File[] = [];
  isFieldsDisabled = false;
  isFieldDisabledPayment = true;
  selectedPatient: string = '';

  selectedDependent: number = 0;
  SelectedUniqueInsured: number = 0;
  SelectedClientCode: number = 0;

  filteredClientAccountType: string[] = [];
  filteredAccountCurrency: string[] = [];
  filteredCustomerName: string[] = [];
  AccountCurrencyExist: boolean = false;
  isNuevaCuenta: boolean = false;

  public accountsList: ClientAccount[] = [];

  // Notificaciones
  public showNotification = false;
  public notificationType: 'success' | 'error' | 'warning' = 'success';
  public notificationTitle = '';
  public notificationMessage = '';

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild(CamposComponent) camposComponent!: CamposComponent;

  claimOriginLocations = [
    { Code: 1, description: 'Local' },
    { Code: 2, description: 'Extranjero' },
  ];

  constructor(
    private reclamacionesService: ReclamacionesService,
    public fileHandler: FileHandlerService,
    private authService: AuthService,
    private gAnalytics: GoogleAnalyticsService
  ) {
    this.title = 'Reembolsos';
  }

  /**
   * Maneja los cambios en los filtros de búsqueda
   * @param filters Objeto con los filtros aplicados
   */
  onFilterChange(filters: ReembolsosFilter): void {
    // Cancelar cualquier suscripción anterior
    if (this.currentSubscription) {
      this.currentSubscription.unsubscribe();
    }

    // Si no hay filtros, reiniciar datos
    if (Object.keys(filters).length === 0) {
      this.reembolsoData = undefined;
      this.selectedFiles = [];
      this.fileHandler.selectedFiles = [];
      this.errorStatus = undefined;
      return;
    }

    // Crear el request
    const request: ReembolsosRequest = {
      idType: filters.idType || 0,
      IdNumber: filters.IdNumber || '',
    };

    const request2: CustomerInformationRequest = {
      clientCode: '',
      policynumber: '',
      idnumber: filters.IdNumber || '',
      COMPANIA_SC: 0,
    };

    this.currentSubscription = this.reclamacionesService
      .getReembolsos(request)
      .pipe(
        switchMap((response: ReembolsosResponse) => {
          if (!response.CustomerInformation?.length) {
            return this.reclamacionesService
              .getCustomerInformation(request2)
              .pipe(
                map((customerResponse: any) => ({
                  ...response,
                  CustomerInformation: [
                    ...customerResponse.CustomerInformation.CustomerInformation,
                  ],
                  MedicalTreatment: [
                    ...customerResponse.MedicalTreatments.result
                      .MedicalTreatment,
                  ],
                  PolicyTitular: [
                    ...customerResponse.CustomerInformation.PolicyTitular,
                  ],
                }))
              );
          }
          return of(response);
        })
      )
      .subscribe({
        next: (response: any) => {
          this.limpiarCampos();
          this.reembolsoData = response;
          this.filteredClientAccountType =
            this.reembolsoData?.ClientAccount?.map(
              (cuenta) => cuenta.BankAccountType
            ) || [];

          this.filteredClientAccountType =
            this.filteredClientAccountType.filter(
              (cuenta, index) =>
                this.filteredClientAccountType.indexOf(cuenta) === index
            );

          this.filteredAccountCurrency =
            this.reembolsoData?.ClientAccount?.map(
              (cuenta) => cuenta.CCurrency
            ) || [];

          this.filteredAccountCurrency = this.filteredAccountCurrency.filter(
            (cuenta, index) =>
              this.filteredAccountCurrency.indexOf(cuenta) === index
          );

          this.filteredCustomerName =
            this.reembolsoData?.CustomerInformation?.map(
              (customer) => customer.Name
            ) || [];

          this.filteredCustomerName = this.filteredCustomerName.filter(
            (customer, index) =>
              this.filteredCustomerName.indexOf(customer) === index
          );

          this.selectedPolicy =
            this.reembolsoData?.CustomerInformation?.[0]?.PolicyNumber || '';
          this.SelectedUniqueInsured =
            this.reembolsoData?.CustomerInformation?.[0]?.UniqueInsured || 0;
          this.selectedDependent =
            this.reembolsoData?.CustomerInformation?.[0]?.Dependent || 0;
          this.SelectedClientCode =
            this.reembolsoData?.CustomerInformation?.[0]?.ClientCode || 0;
        },
        error: (error) => {
          this.reembolsoData = undefined;
          this.hasSearched = true;
          this.errorStatus = error.status;
        },
      });
  }

  /**
   * Maneja el cambio en el tipo de pago seleccionado
   * @param PaymentTypeCode Código del tipo de pago seleccionado
   */
  handlePaymentTypeChange(PaymentTypeCode: string) {

    this.selectedPaymentType = PaymentTypeCode.toString();

    this.gAnalytics.trackEvent('cambio_tipo_pago_reembolsos', {
      page: '/reembolsos',
      action: 'Cambio de tipo de pago en solicitud de reembolso',
      tipo_pago_reembolso: this.selectedPaymentType === '2' ? "Cheque" : "Deposito"
    })

    this.selectedBank = '';
    this.accountNumber = '';
    this.selectedAccountType = '';
    this.selectedCurrencyAccount = '';
  }

  /**
   * Activa el input de archivo al hacer clic en el botón
   * @param event Evento del clic
   */
  triggerFileInput(event: any): void {
    event.preventDefault();
    this.fileInput.nativeElement.click();
  }

  /**
   * Valida si todos los campos requeridos del formulario están completos
   * @returns boolean indicando si el formulario es válido
   */
  isFormValid(): boolean {
    return (
      this.selectedOrigin !== '' &&
      this.selectedProcedure !== '' &&
      this.fechaServicio !== '' &&
      this.monto !== '' &&
      this.selectedCurrency !== '' &&
      this.selectedPatient !== ''
    );
  }

  /**
   * Agrega un nuevo servicio a la lista
   */

  agregarServicio(): void {
    if (!this.isFormValid()) return;
    // Verificar si la fecha seleccionada excede el tiempo máximo de reclamación
    const selectedDate = new Date(this.fechaServicio);
    const todayDate = new Date();

    // Obtener la descripción del origen seleccionado
    const selectedOrigin = this.claimOriginLocations.find(
      (origin) => origin.Code === Number(this.selectedOrigin)
    );

    if (!this.selectedPatient) {
      this.mostrarNotificacion('error', '', 'Debe seleccionar un paciente.');
      return;
    }

    if (!selectedOrigin) {
      console.error('Origen de reclamación no válido.');
      return; // Salir si el origen no es válido
    }

    // Validar que la moneda sea consistente con servicios anteriores
    if (this.servicios.length > 0) {
      const firstCurrency = this.servicios[0].moneda;
      if (

        (firstCurrency === '81' || firstCurrency === '4') &&
        this.selectedCurrency !== firstCurrency
      ) {
        this.mostrarNotificacion(
          'error',
          '',
          'Todos los servicios deben tener la misma moneda previamente.'
        );
        return;

      }
    }

    const selectedOriginDescription = selectedOrigin.description;

    if (
      selectedOriginDescription === 'Local' &&
      selectedDate < new Date(todayDate.setDate(todayDate.getDate() - 90))
    ) {
      this.mostrarNotificacion(
        'error',
        '',
        'No se pudo agregar el servicio. La fecha seleccionada excede el tiempo máximo de reclamación. Local: Hasta 90 días.'
      );
      return;

    } else if (
      selectedOriginDescription === 'Extranjero' &&
      selectedDate < new Date(todayDate.setDate(todayDate.getDate() - 180))
    ) {
      this.mostrarNotificacion(
        'error',
        '',
        'No se pudo agregar el servicio. La fecha seleccionada excede el tiempo máximo de reclamación. Extranjero: Hasta 180 días.'
      );
      return;
    }

    // Deshabilitar campos si no hay servicios
    if (this.servicios.length === 0) {
      this.isFieldsDisabled = true;
      this.isFieldDisabledPayment = false;
    }



    // Crear nuevo servicio
    const nuevoServicio: Servicio = {
      nombre: this.servicioName,
      fecha: this.fechaServicio,
      monto: this.monto,
      moneda: this.selectedCurrency,
      codigo: this.currencyCode,
    };


    // Servicio google analytics para trackear las solicitudes de reembolsos que mas se seleccionan.
    this.gAnalytics.trackEvent('agregar_servicio_reembolso', {
      page: '/reembolsos',
      action: 'Agregar servicio a la solicitud de Reembolso',
      servicio_nombre: nuevoServicio.nombre,
      servicio_fecha: nuevoServicio.fecha,
      servicio_monto: nuevoServicio.monto,
      servicio_moneda: nuevoServicio.codigo,
      servicio_origen: selectedOriginDescription
    })


    // Agregar el nuevo servicio a la lista
    this.servicios.push(nuevoServicio);
    this.limpiarCamposServicio();
    this.hasServicio = true;
    this.actualizarResumen();

  }

  /**
   * Actualiza el resumen de servicios en formato texto
   */

  private actualizarResumen(): void {
    this.resumenServicios = this.servicios
      .map((servicio, index) => {
        const formattedDate = servicio.fecha.split('-').reverse().join('/');


        return (
          `Servicio ${index + 1}: ${servicio.nombre}\n` +
          `Fecha: ${formattedDate}\n` +
          `Monto: ${servicio.codigo}$${servicio.monto}`

        );
      })
      .join('\n\n');
  }

  /**
   * Limpia los campos del formulario de servicio
   */

  private limpiarCamposServicio(): void {
    this.selectedProcedure = '';
    this.fechaServicio = '';
    this.monto = '';
    this.servicioName = '';
  }


  /**
   * Inicia el proceso de eliminación de un servicio
   * @param index Índice del servicio a eliminar
   */

  eliminarServicio(index: number): void {

    this.gAnalytics.trackEvent('abrir_eliminar_servicio_reembolso', {
      page: '/reembolsos',
      action: 'Abrir modal de eliminicacion de servicio'
    })


    this.servicioAEliminar = index;
    this.showConfirmModal = true;
    this.isFieldsDisabled = false;
  }


  /**
   * Confirma la eliminación del servicio seleccionado
   */

  confirmarEliminacion(): void {
    if (this.servicioAEliminar !== undefined) {
      this.servicios.splice(this.servicioAEliminar, 1);
      this.actualizarResumen();


      if (this.servicios.length === 0) {
        this.hasServicio = false;
      }

    }


    this.gAnalytics.trackEvent('eliminar_servicio_reembolso', {
      page: '/reembolsos',
      action: 'Eliminar servicio de Reembolso'
    })

    this.showConfirmModal = false;
    this.servicioAEliminar = undefined;

  }

  /**
   * Cancela la eliminación del servicio
   */
  cancelarEliminacion(): void {
    this.gAnalytics.trackEvent('cancelar_eliminicacion_servicio_reembolso', {
      page: '/reembolsos',
      action: 'Cancelar la eliminación del servicio de reembolso'
    })


    this.showConfirmModal = false;
  }


  /**
   * Envía la solicitud de reembolso al servidor
   */
  submitReembolso(): void {
    //Obtiene el monto total de los servicios en la solicitud de reembolso para pasarlo a Google Analytics
    const montoTotal = this.servicios.reduce((total, servicio) => {
      return total + Number(servicio.monto.replace(/,/g, ''));
    }, 0);


    //Validación de que haya al menos un servicio agregado
    if (this.servicios.length === 0) {
      this.mostrarNotificacion(
        'error',

        '',
        'Debe agregar un servicio antes de enviar la solicitud.'

      );
      return;
    }

    //Validaciones cuando el tipo de pago es depósito
    if (this.selectedPaymentType === '1') {
      if (
        !this.selectedBank ||
        !this.accountNumber ||
        !this.selectedAccountType ||
        !this.selectedCurrency
      ) {
        this.mostrarNotificacion(
          'error',
          '',
          'Por favor, complete todos los campos requeridos para el depósito.'
        );
        return;
      }
    }
    if (this.selectedFiles.length === 0) {
      this.mostrarNotificacion('error', '', 'Debe subir al menos un archivo.');
      return;
    }

    const request: ReembolsoSaveRequest = {
      PolicyNumber:
        this.reembolsoData?.CustomerInformation?.[0]?.PolicyNumber || '',
      Insured: this.reembolsoData?.CustomerInformation?.[0]?.Insured || 0,
      UniqueInsured: this.SelectedUniqueInsured,
      Dependent: this.selectedDependent,
      ClaimOriginalLocation: this.selectedOrigin,
      StartServiceDate: this.fechaServicio,
      CCurrency: Number(this.selectedCurrency),
      PaymentForm: Number(this.selectedPaymentType),
      CurrencyAccount: Number(this.selectedCurrencyAccount),
      BaseValue: Number(this.monto.replace(/,/g, '')),
      BankCode: Number(this.selectedBank),
      BankAccountType: this.selectedAccountType,
      AccountNumber: this.accountNumber,
      ClientCode: this.SelectedClientCode,
      DSource: 1,
      USUARIO: this.authService.getUserId(),

      ServiceCatType: this.servicios.map((servicio) => ({
        IdTreatment: servicio.nombre,
        Servicecategory: 1,
        StartServiceDate: servicio.fecha,
        BaseValue: Number(servicio.monto.replace(/,/g, '')),
      })),

    };
    this.reclamacionesService
      .saveReembolso(request)
      .pipe(
        switchMap((response) => {
          if (response.status === 200) {
            this.claimNumber = Number(response.result.ClaimNumber[0]);
            return this.reclamacionesService.uploadFile({
              ClaimNumber: Number(response.result.ClaimNumber[0]),
              Files: this.selectedFiles,
            });
          }
          throw new Error(response.error);
        })
      )
      .subscribe({
        next: () => {
          this.showResponseMessage(
            `Su solicitud ha sido debidamente completada bajo el no. ${this.claimNumber}, estará recibiendo respuesta en las próximas 48 horas laborables`
          );

            //Evento para trackear solicitud de reembolso realizada con exito en Google Analytics
          const moneda = this.selectedCurrency === '81' ? 'DOP' : 'USD';
 
          this.gAnalytics.trackEvent('enviar_solicitud_reembolso', {
            page: '/reembolsos',
            action: 'Enviar solicitud de Reembolso',
            banco_seleccionado_reembolso: this.bancoSeleccionado,
            tipo_cuenta_banco_reembolso: this.tipoCuentaBanco,
            monto_solicitud_reembolso: this.selectedCurrency === '81' ? montoTotal.toString() : undefined,
            monto_solicitud_reembolso_usd: this.selectedCurrency === '4' ? montoTotal.toString() : undefined,
            cantidad_servicios_reembolsos: this.servicios.length,
            moneda_solicitud_reembolso: moneda,
            tipo_pago_reembolso: this.selectedPaymentType === '2' ? 'Cheque' : 'Deposito'
          })

          
          this.limpiarCampos();
          this.isFieldsDisabled = false;

          // Reset the filters in CamposComponent
          if (this.camposComponent) {
            this.camposComponent.resetFields();
            this.onFilterChange({});
          }
        },
        error: (error) => {
          this.mostrarNotificacion('error', '', error);
          console.error('Error:', error.error);
        },
      });
  }

  /**
   * Limpia todos los campos del formulario
   */
  limpiarCampos(): void {
    this.selectedOrigin = '';
    this.selectedProcedure = '';
    this.fechaServicio = '';
    this.monto = '';
    this.selectedCurrency = '';
    this.selectedPaymentType = '';
    this.selectedBank = '';
    this.accountNumber = '';
    this.selectedAccountType = '';
    this.selectedCurrencyAccount = '';
    this.resumenServicios = '';
    this.hasServicio = false;
    this.selectedFiles = [];
    this.fileHandler.selectedFiles = [];
    this.currencyCode = '';
    this.servicios.length = 0;
    this.selectedPatient = '';
    this.isFieldsDisabled = false;
    this.isNuevaCuenta = false;
  }

  /**
   * Muestra el modal con el mensaje de respuesta
   * @param message Mensaje a mostrar
   */
  showResponseMessage(message: string): void {
    this.responseMessage = message;
    this.showMessageModal = true;
  }

  /**
   * Cierra el modal de mensaje
   */
  closeMessageModal(): void {
    this.showMessageModal = false;
  }

  /**
   * Maneja el input del campo monto, formateando el valor
   * @param evento Evento del input
   */
  handleMontoInput(evento: any): void {
    const entrada = evento.target;
    let valor = entrada.value;
    valor = valor.replace(/[^\d.,]/g, '');
    const valorFormateado = formatAmount(valor);
    this.monto = valorFormateado;
  }

  /**
   * Establece el código de moneda basado en la selección
   */
  setCurrencyCode(): void {
    this.selectedBank = '';
    this.accountNumber = '';
    this.selectedAccountType = '';

    this.currencyCode = this.reembolsoData?.CurrencyInformation?.filter(
      (currency) => currency.CurrencyCode == parseInt(this.selectedCurrency)
    )[0].InternationalCode!;

    const currencyCodeSelected =
      this.reembolsoData?.CurrencyInformation?.filter(
        (currency) => currency.CurrencyCode == parseInt(this.selectedCurrency)
      )[0].CurrencyCode;

    let arreglo = this.reembolsoData?.ClientAccount?.map((account) =>
      parseInt(account.CCurrency.trim())
    );

    this.AccountCurrencyExist = arreglo
      ? arreglo.includes(currencyCodeSelected!)
      : false;
  }

  /**
   * Establece el nombre del servicio basado en la selección
   */
  setServicioName(): void {
    this.servicioName = this.reembolsoData?.MedicalTreatment?.filter(
      (procedure) => procedure.OCode == Number(this.selectedProcedure)
    )[0].StringData!;
  }


  /**
   * Maneja la selección de archivos
   * @param event Evento de selección de archivos
   */
  onFileSelected(event: any): void {
    const result = this.fileHandler.addFiles(event.target.files);
    if (!result.success && result.message) {
      alert(result.message);
    }

    this.selectedFiles = this.fileHandler.getFiles();
  }

  /**
   * Muestra una notificación temporal
   * @param type Tipo de notificación (success/error/warning)
   * @param title Título de la notificación
   * @param message Mensaje de la notificación
   */
  mostrarNotificacion(
    type: 'success' | 'error' | 'warning',
    title: string,
    message: string
  ) {
    this.notificationType = type;
    this.notificationTitle = title;
    this.notificationMessage = message;
    this.showNotification = true;

    setTimeout(() => {
      this.showNotification = false;
    }, 5000);
  }

  /**
   * Verifica si se puede enviar la solicitud
   * @returns boolean indicando si el botón de enviar debe estar habilitado
   */
  isSubmitEnabled(): boolean {
    // Verificar si hay información de la póliza
    if (!this.reembolsoData?.CustomerInformation?.length) {
      return false;
    }

    // Verificar si hay al menos un servicio agregado
    if (this.servicios.length === 0) {
      return false;
    }

    // Verificar información de pago
    if (!this.selectedPaymentType) {
      return false;
    }

    // Si el tipo de pago es depósito (type '1'), verificar campos adicionales
    if (this.selectedPaymentType === '1') {
      if (
        !this.selectedBank ||
        !this.accountNumber ||
        !this.selectedAccountType ||
        !this.selectedCurrency
      ) {
        return false;
      }
    }

    // Verificar si se han subido archivos
    if (!this.selectedFiles.length) {
      return false;
    }

    return true;
  }

  /**
   * Valida que solo se ingresen números
   * @param event Evento del teclado
   * @returns boolean indicando si la tecla presionada es válida
   */
  onlyNumbers(event: KeyboardEvent): boolean {
    return (
      /[0-9]/.test(event.key) ||
      ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(
        event.key
      )
    );
  }

  /**
   * Maneja la selección de un banco
   * @param bankCode Código del banco seleccionado
   */
  onSelectedBank(bankCode: string): void {
    const bank = this.reembolsoData?.ClientAccount?.find(
      (bank) => bank.BankCode.toString() === bankCode
    );
    this.accountsList =
      this.reembolsoData?.ClientAccount?.filter(
        (account) => account.BankCode.toString() === bank?.BankCode.toString()
      ) || [];

    if (this.AccountCurrencyExist) {
      this.accountNumber = bank?.AccountNumber || '';
      this.selectedAccountType = bank?.BankAccountType || '';
      this.selectedCurrencyAccount = bank?.CCurrency || '';
    }
  }

  /**
   * Maneja la selección de una nueva cuenta bancaria
   * Resetea los campos relacionados con la cuenta cuando se cambia la opción
   */
  onNuevaCuentaChange(): void {
    if (this.isNuevaCuenta) {
      this.AccountCurrencyExist = false;
      this.gAnalytics.trackEvent('agregar_nueva_cuenta', {
        page: '/reembolsos',
        action: 'Seleccionar agregar nueva cuenta bancaria para solicitud de reembolso'
      })
    } else {
      this.AccountCurrencyExist = true;
      this.gAnalytics.trackEvent('deseleccionar_nueva_cuenta', {
        page: '/reembolsos',
        action: 'Deseleccionar agregar nueva cuenta bancaria para solicitud de reembolso'
      })
    }

    this.selectedBank = '';
    this.accountNumber = '';
    this.selectedAccountType = '';
    this.accountsList = [];
  }

  /**
   * Maneja la selección de una póliza
   * Actualiza los campos relacionados con el paciente basado en la póliza seleccionada
   * @param policy Número de póliza seleccionada
   */
  onSelectedPolicy(policy: string): void {
    const policyPatient = this.reembolsoData?.CustomerInformation?.filter(
      (titular) => titular.PolicyNumber === policy
    );
    this.selectedPatient = policyPatient?.[0]?.Name || '';
    this.SelectedUniqueInsured = policyPatient?.[0]?.UniqueInsured || 0;
    this.selectedDependent = policyPatient?.[0]?.Dependent || 0;
    this.SelectedClientCode = policyPatient?.[0]?.ClientCode || 0;
  }

  /**
   * Maneja la selección de un paciente
   * Actualiza los campos relacionados con el paciente basado en el nombre seleccionado
   * @param policy Nombre del paciente seleccionado
   */
  onSelectedPatient(policy: string): void {
    const policyPatient = this.reembolsoData?.CustomerInformation?.filter(
      (titular) => titular.Name === policy
    );
    this.selectedPatient = policyPatient?.[0]?.Name || '';
    this.SelectedUniqueInsured = policyPatient?.[0]?.UniqueInsured || 0;
    this.selectedDependent = policyPatient?.[0]?.Dependent || 0;
    this.SelectedClientCode = policyPatient?.[0]?.ClientCode || 0;
  }

  onClearFields() {
    this.hasSearched = false;
    this.reembolsoData = undefined;
  }

   /**
   * Obtiene el nombre del banco seleccionado de forma robusta
   */
  get bancoSeleccionado(): string {
    return this.selectedBank
      ? (this.reembolsoData?.ClientAccount?.find((bank) => bank.BankCode.toString() === this.selectedBank)?.BankName
        || this.reembolsoData?.BankInformation?.find((bank) => bank.BankCode.toString() === this.selectedBank)?.BankName
        || this.selectedBank)
      : 'N/A';
  }

  /**
   * Obtiene el tipo de cuenta bancaria seleccionada de forma robusta
   */
  get tipoCuentaBanco(): string {
    return this.selectedAccountType
      ? (this.reembolsoData?.ClientAccount?.find((account) => account.BankAccountType === this.selectedAccountType)?.BankAccountType === 'A'
        ? 'Ahorro'
        : this.reembolsoData?.ClientAccount?.find((account) => account.BankAccountType === this.selectedAccountType)?.BankAccountType === 'C'
          ? 'Corriente'
          : this.selectedAccountType === 'A' ? 'Ahorro' : this.selectedAccountType === 'C' ? 'Corriente' : this.selectedAccountType)
      : 'N/A';
  }
}
